module.exports = __webpack_public_path__ + "static/media/img_1.a81d25bb.jpg";